export function SchemaEmptySelection(props: { label: string }): React.JSX.Element {
  return <div className="schema-empty-detail">Select or add a {props.label} to begin editing.</div>;
}

export function SchemaEditorActions(props: {
  busy: boolean;
  dirty: boolean;
  onDelete: () => void;
  onReset: () => void;
  onSave: () => Promise<void>;
  extra?: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className="schema-editor-actions">
      <button className="danger-button" disabled={props.busy} onClick={props.onDelete} type="button">Delete</button>
      {props.extra}
      <span />
      <button className="secondary-button" disabled={props.busy || !props.dirty} onClick={props.onReset} type="button">Reset unsaved</button>
      <button className="primary-button" disabled={props.busy || !props.dirty} onClick={props.onSave} type="button">{props.busy ? 'Saving…' : 'Save draft'}</button>
    </div>
  );
}
